import { Microphone, Notes, PlayOne } from '@icon-park/react';
import type { ReactElement } from 'react';

import { LEARNING_RESOURCE_TYPE } from '@didaskill/domain/learning-resources/constants';
import { BADGE_VARIANTS } from '@didaskill/ui/design-system';

export const LEARNING_RESOURCE_ICON_MAPPING: Record<LEARNING_RESOURCE_TYPE, ReactElement> = {
  [LEARNING_RESOURCE_TYPE.VIDEO]: <PlayOne />,
  [LEARNING_RESOURCE_TYPE.FILE]: <Notes />,
  [LEARNING_RESOURCE_TYPE.AUDIO]: <Microphone />,
  [LEARNING_RESOURCE_TYPE.REPLAY]: <PlayOne />,
} as const;

export const LEARNING_RESOURCE_ICON_VARIANT_MAPPING: Record<
  LEARNING_RESOURCE_TYPE,
  BADGE_VARIANTS
> = {
  [LEARNING_RESOURCE_TYPE.VIDEO]: BADGE_VARIANTS.PRIMARY,
  [LEARNING_RESOURCE_TYPE.FILE]: BADGE_VARIANTS.SECONDARY,
  [LEARNING_RESOURCE_TYPE.AUDIO]: BADGE_VARIANTS.TERTIARY,
  [LEARNING_RESOURCE_TYPE.REPLAY]: BADGE_VARIANTS.PRIMARY,
} as const;
